import React from "react";

const biomedicalWasteData = [
  {
    month: "Mar-24",
    red: 1357,
    yellow: 1928,
    blue: 297,
    ppc: 41,
    total: 3623,
    general: 10869,
  },
  {
    month: "Apr-24",
    red: 1520,
    yellow: 2416,
    blue: 301,
    ppc: 34,
    total: 4271,
    general: 12810,
  },
  {
    month: "May-24",
    red: 940,
    yellow: 1276,
    blue: 211,
    ppc: 89,
    total: 2516,
    general: 7548,
  },
  {
    month: "Jun-24",
    red: 1425,
    yellow: 2091,
    blue: 277,
    ppc: 32,
    total: 3825,
    general: 11475,
  },
  {
    month: "Jul-24",
    red: 1415,
    yellow: 1970,
    blue: 298,
    ppc: 36,
    total: 3719,
    general: 11157,
  },
  {
    month: "Aug-24",
    red: 1442,
    yellow: 1748,
    blue: 238,
    ppc: 41,
    total: 3469,
    general: 10407,
  },
  {
    month: "Sep-24",
    red: 1447,
    yellow: 1807,
    blue: 414,
    ppc: 20,
    total: 3688,
    general: 11064,
  },
  {
    month: "Oct-24",
    red: 1293,
    yellow: 1750,
    blue: 323,
    ppc: 38,
    total: 3404,
    general: 10212,
  },
  {
    month: "Nov-24",
    red: 948,
    yellow: 1145,
    blue: 209,
    ppc: 47,
    total: 2349,
    general: 7047,
  },
  {
    month: "Dec-24",
    red: 954,
    yellow: 1215,
    blue: 380,
    ppc: 66,
    total: 2615,
    general: 7845,
  },
  {
    month: "Jan-25",
    red: 1097,
    yellow: 1236,
    blue: 231,
    ppc: 35,
    total: 2599,
    general: 7797,
  },
  {
    month: "Feb-25",
    red: 998,
    yellow: 1115,
    blue: 252,
    ppc: 32,
    total: 2397,
    general: 7191,
  },
  {
    month: "Mar-25",
    red: 1118,
    yellow: 1218,
    blue: 293,
    ppc: 31,
    total: 2660,
    general: 7980,
  },
  {
    month: "Apr-25",
    red: 1009,
    yellow: 1235,
    blue: 298,
    ppc: 36,
    total: 2578,
    general: 7734,
  },
  {
    month: "May-25",
    red: 1274,
    yellow: 1331,
    blue: 359,
    ppc: 17,
    total: 2981,
    general: 9003,
  },
  {
    month: "June-25",
    red: 1092,
    yellow: 971,
    blue: 277,
    ppc: 41,
    total: 2381,
    general: 7143,
  },
  {
    month: "July-25",
    red: 1301,
    yellow: 1013,
    blue: 262,
    ppc: 37,
    total: 2613,
    general: 7839,
  },
  {
    month: "Aug-25",
    red: 1158,
    yellow: 883,
    blue: 263,
    ppc: 31,
    total: 2335,
    general: 7005,
  },
  {
    month: "Sep-25",
    red: 1084,
    yellow: 833,
    blue: 324,
    ppc: 34,
    total: 2275,
    general: 6825,
  },
  {
    month: "Oct-25",
    red: 1214,
    yellow: 1043,
    blue: 280,
    ppc: 35,
    total: 2572,
    general: 7716,
  },
  {
    month: "Nov-25",
    red: 1306,
    yellow: 1062,
    blue: 307,
    ppc: 36,
    total: 2711,
    general: 8133,
  },
  {
    month: "Dec-25",
    red: 1713,
    yellow: 1528,
    blue: 328,
    ppc: 75,
    total: 3644,
    general: 10838,
  },
  {
    month: "Jan-26",
    red: 1542,
    yellow: 1523,
    blue: 215,
    ppc: 31,
    total: 3311,
    general: 9933,
  },
  {
    month: "Feb-26",
    red: 1514,
    yellow: 1690,
    blue: 298,
    ppc: 34,
    total: 3536,
    general: 10608,
  },
  {
    month: "Mar-26",
    red: 1654,
    yellow: 1908,
    blue: 321,
    ppc: 42,
    total: 3925,
    general: 11775,
  },
  {
    month: "Apr-26",
    red: 1380,
    yellow: 1772,
    blue: 274,
    ppc: 34,
    total: 3460,
    general: 10380,
  },
  {
    month: "May-26",
    red: 1029,
    yellow: 1602,
    blue: 249,
    ppc: 29,
    total: 2909,
    general: 8727,
  },
  {
    month: "JUNE-26",
    red: 1060.3,
    yellow: 1687.4,
    blue: 236.7,
    ppc: 43.5,
    total: 3027.9,
    general: 9083.7,
  },
  {
    month: "JULY-26",
    red: 1199.09,
    yellow: 1684.5,
    blue: 339.9,
    ppc: 42.5,
    total: 3267.9,
    general: 9797.9,
  },
  {
    month: "AUG-26",
    red: 1595.9,
    yellow: 1706.8,
    blue: 327.6,
    ppc: 40.7,
    total: 3671,
    general: 11013,
  },
  {
    month: "SEP-26",
    red: 1468,
    yellow: 1681,
    blue: 321,
    ppc: 62,
    total: 3532,
    general: 10596,
  },
];

const BiomedicalWaste = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Heading */}
        <div className="text-center mb-10">
          <p className="text-sm font-semibold uppercase tracking-wider text-green-600 mb-2">
            Hospital Environmental Management
          </p>

          <h1 className="text-3xl md:text-4xl font-bold text-gray-900">
            Biomedical Waste Management
          </h1>

          <p className="mt-4 max-w-3xl mx-auto text-gray-600">
            Monthly biomedical waste data recorded across different waste
            categories.
          </p>
        </div>

        {/* Table Card */}
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">

          <div className="px-6 py-5 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-gray-900">
              Biomedical Waste Data
            </h2>

            <p className="text-sm text-gray-500 mt-1">
              Monthly waste quantities from March 2024 to September 2026
            </p>
          </div>

          {/* Responsive Table */}
          <div className="overflow-x-auto">
            <table className="w-full min-w-[900px]">

              {/* Table Header */}
              <thead>
                <tr className="bg-gray-100 text-gray-700">

                  <th className="px-4 py-4 text-left font-semibold">
                    Month
                  </th>

                  <th className="px-4 py-4 text-center font-semibold">
                    Red Bags Wt
                  </th>

                  <th className="px-4 py-4 text-center font-semibold">
                    Yellow Bags Wt
                  </th>

                  <th className="px-4 py-4 text-center font-semibold">
                    Blue Bags Wt
                  </th>

                  <th className="px-4 py-4 text-center font-semibold">
                    PPC Wt
                  </th>

                  <th className="px-4 py-4 text-center font-semibold">
                    Total BMW Wt
                  </th>

                  <th className="px-4 py-4 text-center font-semibold">
                    General Waste Wt
                  </th>

                </tr>
              </thead>

              {/* Table Body */}
              <tbody>
                {biomedicalWasteData.map((item, index) => (
                  <tr
                    key={item.month}
                    className={`border-b border-gray-100 ${
                      index % 2 === 0
                        ? "bg-white"
                        : "bg-gray-50"
                    } hover:bg-green-50 transition`}
                  >

                    <td className="px-4 py-3 font-medium text-gray-900">
                      {item.month}
                    </td>

                    <td className="px-4 py-3 text-center text-gray-700">
                      {item.red}
                    </td>

                    <td className="px-4 py-3 text-center text-gray-700">
                      {item.yellow}
                    </td>

                    <td className="px-4 py-3 text-center text-gray-700">
                      {item.blue}
                    </td>

                    <td className="px-4 py-3 text-center text-gray-700">
                      {item.ppc}
                    </td>

                    <td className="px-4 py-3 text-center text-gray-700">
                      {item.total}
                    </td>

                    <td className="px-4 py-3 text-center text-gray-700">
                      {item.general}
                    </td>

                  </tr>
                ))}
              </tbody>

            </table>
          </div>

        </div>
      </div>
    </section>
  );
};

export default BiomedicalWaste;
